module.exports = __webpack_public_path__ + "static/media/hp2.88f3fb36.gif";